import { NavLink } from "react-router-dom";

const NotFound = () => {
    return (
        <div id="not-found" className="container p-4 justify-content-center align-items-center">

            <p className="chocolate title heading-2" align="center">
                404 - Page Not Found
            </p>

            <p className="light-chocolate text-404 title content-2" align="center">
                Oops! Looks like you have sailed the wrong way! <br />
                <img id="boat404" src="/assets/images/boat.jpg" alt="404" /> <br />
                <NavLink to="/portfolio">Explore our featured content</NavLink>
            </p>


            <a style={{ display: 'none' }} href="https://www.freepik.com/free-vector/wooden-pirate-ship-with-black-sails-jolly-roger-flag-sea_2873579.htm#page=2&query=old%20sailing%20boat%20icon%20svg&position=33&from_view=search&track=ais">
                Image by macrovector on Freepik
            </a>
        </div>

    );
}

export default NotFound;